import { createFileRoute } from '@tanstack/react-router'
import { TradeGate } from '@/components/trade/TradeGate'
import { TradePage, type TradeSearch, type TradeTab } from '@/components/trade/TradePage'

const TABS: TradeTab[] = ['deliveries', 'clients', 'prices']

function TradeRoutePage() {
  const search = Route.useSearch()
  return (
    <TradeGate>
      <TradePage search={search} />
    </TradeGate>
  )
}

const str = (v: unknown, re: RegExp) => (typeof v === 'string' && re.test(v) ? v : undefined)

export const Route = createFileRoute('/admin/trade')({
  validateSearch: (s: Record<string, unknown>): TradeSearch => ({
    tab: typeof s.tab === 'string' && (TABS as string[]).includes(s.tab) ? (s.tab as TradeTab) : undefined,
    client: str(s.client, /^[0-9a-f-]{36}$/),
    delivery: str(s.delivery, /^[0-9a-f-]{36}$/),
  }),
  component: TradeRoutePage,
})
